import request from '@/utils/http'

// 新增用户数据权限
export const login = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/mobile/login`,
        method: 'post',
        data: params,
    })
}

// 发送验证码短信前获取对应的 UUID
export const getUuidBeforeSendMessage = () => {
    return request({
        url: `/api-ntp/ntp/apiAuth/getRequestUuid`,
        method: 'get',
    })
}

// 登录发送短信
export const sendMessage = (params, options) => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/sendMessage/${params.mobile}/${params.action}?uuid=${params.uuid}`,
        method: 'get',
        options,
    })
}
// 退出登录
export function Logout(params) {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/logout`,
        method: 'get',
    })
}
// 获取用户信息
export const getLogIn = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/getLogIn`,
        method: 'get',
    })
}
// 获取当前用户菜单
export const getAllResources = params => {
    return request({
        url: `/api-ntp/ntp/baseResourcesInfo/getAllResources`,
        method: 'post',
        data: params,
    })
}
// 重置密码
export const resetPassWord = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/resetPassWord`,
        method: 'post',
        data: params,
    })
}
// 切换货主
export const switchOwner = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/switchOwner`,
        method: 'post',
        data: params,
    })
}
// 忘记密码
export const resetNotLoginPassWord = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/resetNotLoginPassWord`,
        method: 'post',
        data: params,
    })
}
